import React, { Component, useState, useEffect } from 'react';
import { BubblesData as BData_1 } from './bubbles-t1.data.js';
import { BubblesData as BData_2 } from './bubbles-t2.data.js';
import { BubblesData as BData_3 } from './bubbles-t3.data.js';
import { BubblesData as BData_4 } from './bubbles-t4.data.js';
import { BubblesData as BData_5 } from './bubbles-t5.data.js';
import { BubblesData as BData_6 } from './bubbles-t6.data.js';
import { BubblesData as BData_7 } from './bubbles-t7.data.js';
import { BubblesData as BData_8 } from './bubbles-t8.data.js';
//import { BData_4 } from './bubbles-t4.data.js';
import PropTypes from 'prop-types';
import i_360 from '../../UI/svg/360.svg'
import i_renders from '../../UI/svg/img.svg'
import ReactDOMServer from 'react-dom/server';

class Bubbles extends Component{

    constructor(props){
        super(props);
        this.array = []
        this.state = {
            aptos: [],
            currentApto: 0
        }
        
    }   

    componentDidMount(){
        
        //console.log("Bubbles Length: ", BData_1.length);
        this.BData = {
            'Torre A Ovalada': BData_1(),
            'Torre B Ovalada': BData_2(),
            'Torre C Ovalada': BData_3(),
            'Torre D Ovalada': BData_4(),
            'Torre F Tira': BData_5(),
            'Torre G Tira': BData_6(),
            'Torre H Tira': BData_7(),
            'Torre I Tira': BData_8(),
        };
        
        this.bubbles = this.BData['Torre A Ovalada'];

        //console.log("BUBBLES LENGTH:::: ",this.bubbles.length)
        this.btnref = React.createRef();
    }

    UpdateBubbles = (aptos, bubbles) => {
        aptos.forEach(apto => {
            bubbles.forEach(frame => {
                for(let bubble of frame) {
                    let count = 0;
                    if(bubble.num === apto.num){
                        
                        //console.log(apto.tipo, apto)
                        bubble.disp = apto.disp
                        bubble.t = apto.t
                        bubble.a = apto.a                        
                        count++;
                        if(count >= 2){
                            break;
                        }                        
                    }
                };
            })
        });
    }

    UpdateAvailability = (aptos, torre) => {
        this.setState(prevState => ({
            aptos: aptos
        }), 
        ()=>{
            this.UpdateBubbles(this.state.aptos, this.bubbles);
            this.createBubbles();
        }) 
        if(this.BData[torre]){
            this.UpdateBubbles(aptos, this.BData[torre]);
        }
    }

    customBubble360Call = (tipo, e) =>
    {
        this.props.onBubble360Click(tipo)
    }

    customBubbleGalleryCall = (tipo, e) =>
    {
        this.props.onBubbleGalleryClick(tipo)
    }

    showToolTip = (apto, e) => {

        console.log(apto)

        this.setState({
            clientX: e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientX : e.clientX, 
            clientY: e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientY : e.clientY,
            apto: apto,
            showToolTip: true,
            currentApto: apto.num
        })

        if(apto.tipo === 'Apto 02' || apto.tipo === 'Apto 03' || apto.tipo === 'Apto 04'){
            this.setState({
                show360: true
            })
        } 
        else 
        {
            this.setState({
                show360: false
            })
        }
       
        if(apto.a){
            if(apto.a.Galeria.length > 0 || apto.a.Planos.length > 0){
                this.setState({
                    showGallery: true
                })
            } 
            else 
            {
                this.setState({
                    showGallery: false
                })
            }
        }        

    }

    hideTooltip = () => {
        //var tooltip = document.getElementById("tooltip");
        //tooltip.style.display = "none";
        this.setState({
            showToolTip: false,
            apto: null
        })
    }
    
    updateBDataRef = () => 
    {
        if(this.props.tower !== ''){
            this.bubbles = this.BData[this.props.tower];
        } else {
            return false;
        }
        return true
    }

    createBubbles = (aptos) => 
    {
        let angle = this.props.angle
        this.array = []

        if(!this.updateBDataRef()){           
            return;
        }
        
        if(this.bubbles[angle] === undefined){
            return this.props.angle
        }        
        
        //console.log("cat:", this.props.category)
        //console.log("tower:", this.props.tower)
        for (let i = 0; i < this.bubbles[angle].length; i++) {
            //console.log(i + ",", this.bubbles[angle][i].verts.length, this.bubbles[angle][i].name, this.bubbles[angle][i].verts[1][0], this.bubbles[angle][i].verts[1][1])
            //console.log("bubble tower:", this.bubbles[angle][i].t)
            
            /*if(this.props.tower !== "" && this.props.tower !== this.bubbles[angle][i].t){
                continue;
            }*/

            if(this.props.apto !== "" && this.props.apto !== this.bubbles[angle][i].num){
                continue;
            }
            /*if(this.props.apto !== "" && this.props.apto !== this.bubbles[angle][i].num){
                continue;
            }*/
            this.array.push(
                <polygon
                key={i} 
                points = {
                    "" + this.bubbles[angle][i].verts[0][0] + "," + this.bubbles[angle][i].verts[0][1] + " " + 
                    this.bubbles[angle][i].verts[1][0] + "," + this.bubbles[angle][i].verts[1][1] + " " + 
                    this.bubbles[angle][i].verts[3][0] + "," + this.bubbles[angle][i].verts[3][1] + " " + 
                    this.bubbles[angle][i].verts[2][0] + "," + this.bubbles[angle][i].verts[2][1]
                }
                style = {{
                    fill: (this.bubbles[angle][i].disp === "DISPONIBLE") ? "rgba(0,255,0,.3)" : 
                    (this.bubbles[angle][i].disp === "VENDIDO") ? "rgba(255,0,0,.3)" : 
                    (this.bubbles[angle][i].disp === "RESERVADO") ? "rgba(255,255,0,.3)" : 
                    "rgba(24,77,71,.3)",
                    stroke: (this.bubbles[angle][i].disp === "DISPONIBLE") ? "rgba(0,128,0,.82)" : 
                    (this.bubbles[angle][i].disp === "VENDIDO") ? "rgba(128,0,0,.82)" : 
                    (this.bubbles[angle][i].disp === "RESERVADO") ? "rgba(128,128,0,.82)": 
                    "rgba(24,77,71,.3)",
                    strokeWidth: 2,
                    visibility: 'visible',
                    cursor: 'pointer'
                }}

                onMouseDown = {this.showToolTip.bind(this, this.bubbles[angle][i])}
                onTouchStart = {this.showToolTip.bind(this, this.bubbles[angle][i])}
                /*onMouseMove = {this.onMouseMove.bind(this)}*/
                //onMouseOut = {this.hideTooltip.bind(this)}
                >
                

                </polygon>
            )
            
        }
        //this.forceUpdate()
    }

    componentDidUpdate(prevProps){

        // TODO: check if this routine can be optimized
        //console.log('[Bubbles]: update, show:', this.props.show, ', tower: ',this.props.tower)
        
        if(!this.props.show){
            return
        }

        this.updateBDataRef();

        if(prevProps.show !== this.props.show){
            this.createBubbles();
            this.forceUpdate();
        }

        if(prevProps.tower !== this.props.tower || prevProps.category !== this.props.category || prevProps.apto !== this.props.apto){
            this.createBubbles();
            this.forceUpdate();
        }

        if(prevProps.angle !== this.props.angle){
            this.createBubbles();
            this.forceUpdate();
        }
    }

    render() {
        if(this.props.show === false){
            return (<div></div>)
        }
        return (
            <div
                style={{
                    pointerEvents: 'none'
                }}
            >
                <svg 
                className = "bubbles-svg"
                width="100vw"
                height="100vh"
                preserveAspectRatio="xMidYMid slice"
                viewBox="0 0 1920 1080"
                style={{
                    overflow: 'hidden',
                    pointerEvents: 'none',
                    position: 'absolute'
                    /*-webkit-user-drag: none,
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)*/
                }}>
                    <g style={{
                        /*transform: 'matrix(1, 0, 0, 1, 8.5601e-05, -36.5)',*/
                        pointerEvents: 'visiblefill'
                    }}>
                        {this.array}
                    </g>
                    
                </svg>

                {
                this.state.showToolTip ? 
                    <div id="tooltip" display="none" 
                    onMouseLeave = { this.hideTooltip.bind(this) }
                    style={{
                        position: "absolute",
                        display: this.state.showToolTip ? "block": "none",
                        padding: '10px',
                        background: 'rgba(0,0,0,.5)',
                        left: this.state.clientX - 100 + 'px',
                        top: this.state.clientY - 60 + 'px',
                        width: '200px',
                        textAlign: 'center',
                        lineHeight: '.25em',
                        pointerEvents: 'all',
                        fontFamily: 'Museo Sans'
                    }}>
                        <p> Apto {this.state.currentApto}</p>
                        <br></br>
                        { /*<p>{ this.state.apto.name } asdasd| { this.state.apto.disp }</p> */ }
                        { this.state.show360 ?
                        <button
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        onClick ={this.customBubble360Call.bind(this, this.state.apto.tipo)}
                        onTouchStart ={this.customBubble360Call.bind(this, this.state.apto.tipo)}
                        >
                            <img 
                            style={{
                                width: '35px',
                                height: '35px'
                            }}
                            src={i_360}></img>
                        </button>
                        : 
                        null
                        }
                        { this.state.showGallery ?
                        <button
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        onClick={this.customBubbleGalleryCall.bind(this, this.state.apto.a)}
                        onTouchStart={this.customBubbleGalleryCall.bind(this, this.state.apto.a)}
                        >
                            <img 
                            style={{
                                width: '35px',
                                height: '35px'
                            }}
                            src={i_renders}></img>
                        </button>
                        : 
                        null
                        }
                    </div>
                    :
                    null
                }
                
            </div>
            
        );
      
    }
}

Bubbles.propTypes = {
    angle: PropTypes.number,
    onBubbleClick: PropTypes.func
}

Bubbles.defaultProps = {
    angle: 0,
    onBubbleClick: () => {}
}

export default Bubbles;